import { rgba } from 'polished';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';
import styled from 'styled-components';
import { Hours, Percent } from '~/components';
import { colors, weights } from '~/styles';
import { Arrow } from '../../components/schedule/allocations/AllocationStyles';

const Container = styled.div`
  max-width: 22rem;
  padding: 0.75rem 0;
  display: flex;
  flex-direction: column;
`;

const Info = styled.div`
  display: flex;
  font-size: 0.75rem;

  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

const Label = styled.div`
  width: 11.5rem;
  padding-right: 0.5rem;
  color: ${colors.grey40};
  font-weight: ${weights.black};
  letter-spacing: 0.0625rem;
  text-transform: uppercase;
  flex-shrink: 0;
  white-space: nowrap;
`;

const Value = styled.div`
  white-space: nowrap;
`;

function Allocated({ cell }) {
  return (
    <Info>
      <Label>Allocated Hours</Label>
      <Value>
        <Hours value={cell.allocated} minimumFractionDigits={0} />{' '}
        {cell.capacity > 0 && (
          <>
            (<Percent value={cell.allocated / cell.capacity} minimumFractionDigits={0} /> allocated)
          </>
        )}
      </Value>
    </Info>
  );
}

export default function TooltipMessage({ cell, referenceElement }) {
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [
      { name: 'offset', options: { offset: [0, 8] } },
      {
        name: 'flip',
        options: {
          allowedAutoPlacements: ['top', 'bottom'],
        },
      },
      { name: 'arrow', options: { element: arrowElement } },
    ],
    placement: 'auto',
    strategy: 'fixed',
  });

  return ReactDOM.createPortal(
    <CellTooltip ref={setPopperElement} style={styles.popper} {...attributes.popper}>
      <Container>
        <Allocated cell={cell} />
      </Container>

      <Arrow ref={setArrowElement} style={styles.arrow} />
    </CellTooltip>,
    document.body,
  );
}

const CellTooltip = styled.div`
  min-width: 7.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  border-radius: 0.3125rem;
  background: ${colors.white};
  border: solid 1px ${colors.grey10};
  box-shadow: 0 0.1875rem 1rem ${rgba(colors.black, 0.25)};
  z-index: 300;

  &[data-popper-placement^='top'] > ${Arrow} {
    bottom: -4px;
  }

  &[data-popper-placement^='bottom'] > ${Arrow} {
    top: -4px;
  }

  &[data-popper-placement^='left'] > ${Arrow} {
    right: -4px;
  }

  &[data-popper-placement^='right'] > ${Arrow} {
    left: -4px;
  }
`;
